/* noms+ · Bundle-Upsell · assets/nplus-bundle.js
   -----------------------------------------------------------
   Rechnet die Summe live aus den ausgewählten Zeilen und legt
   alles in einem Rutsch in den Warenkorb.

   Preise kommen als Ganzzahl in Cent aus Liquid. Es wird nur in
   Cent gerechnet und erst zur Anzeige formatiert – so entstehen
   keine Rundungsfehler durch Fließkomma.
*/
(function () {
  'use strict';

  class NplusBundle extends HTMLElement {
    connectedCallback() {
      this.fixed = this.dataset.mode === 'fixed';
      this.bundleVid = parseInt(this.dataset.bundleVid || '0', 10) || null;
      this.discount = parseInt(this.dataset.discount || '0', 10);
      this.code = (this.dataset.code || '').trim();
      this.boxes = Array.from(this.querySelectorAll('.np-bd__cb'));
      this.btn = this.querySelector('[data-bd-add]');
      this.note = this.querySelector('[data-bd-note]');

      this.fmt = new Intl.NumberFormat(this.dataset.locale || 'de', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR'
      });

      this.boxes.forEach((b) => b.addEventListener('change', () => this.update()));
      if (this.btn) this.btn.addEventListener('click', () => this.add());

      // Festes Set: Preise und Text stehen serverseitig fest, es gibt
      // nichts zu rechnen. Kein update() - sonst wuerden die aus Liquid
      // gerenderten Betraege mit Platzhaltern ueberschrieben.
      if (!this.fixed) this.update();
    }

    get chosen() {
      return this.boxes.filter((b) => b.checked && !b.disabled);
    }

    /** Summe in Cent, vor Rabatt. */
    get full() {
      return this.chosen.reduce((sum, b) => {
        const price = parseInt(b.dataset.price, 10) || 0;
        const qty = parseInt(b.dataset.qty, 10) || 1;
        return sum + price * qty;
      }, 0);
    }

    money(cents) {
      return this.fmt.format(cents / 100);
    }

    update() {
      const full = this.full;
      // Abrunden zugunsten des Kunden, damit der angezeigte Preis nie
      // unter dem liegt, was Shopify später tatsächlich berechnet.
      const off = Math.round((full * this.discount) / 100);
      const now = full - off;

      const set = (sel, val) => {
        const el = this.querySelector(sel);
        if (el) el.textContent = val;
      };
      set('[data-bd-full]', this.money(full));
      set('[data-bd-total]', this.money(now));
      set('[data-bd-save]', this.money(off));

      const saveWrap = this.querySelector('[data-bd-save-wrap]');
      if (saveWrap) saveWrap.hidden = off <= 0;

      const n = this.chosen.length;
      if (this.btn) this.btn.disabled = n === 0;
      if (this.note && !this.note.dataset.sticky && !this.fixed) {
        this.note.textContent = n === 0
          ? 'Bitte mindestens ein Produkt auswählen.'
          : n + (n === 1 ? ' Produkt ausgewählt' : ' Produkte ausgewählt');
      }
    }

    async add() {
      // Festes Set: genau eine Position, naemlich das Bundle-Produkt aus
      // der Shopify Bundles App. Die Zeilen darueber sind reine Anzeige.
      const items = this.fixed
        ? (this.bundleVid ? [{ id: this.bundleVid, quantity: 1 }] : [])
        : this.chosen.map((b) => ({
            id: parseInt(b.dataset.vid, 10),
            quantity: parseInt(b.dataset.qty, 10) || 1
          }));
      if (!items.length) return;

      const label = this.querySelector('[data-bd-cta-label]');
      const before = label ? label.textContent : '';
      this.btn.disabled = true;
      if (label) label.textContent = 'Wird hinzugefügt …';

      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);

        // Ein hinterlegter Code greift nur über den /discount/-Umweg.
        // Im festen Set gibt es keinen Code: der Preis steckt im Produkt.
        if (this.code && !this.fixed) {
          window.location.href = '/discount/' + encodeURIComponent(this.code) + '?redirect=/cart';
          return;
        }
        if (this.dataset.after !== 'stay') {
          window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
          return;
        }

        // Auf der Seite bleiben: Theme über die üblichen Kanäle informieren.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (label) label.textContent = before;
        this.btn.disabled = false;
        if (this.note) {
          this.note.dataset.sticky = '1';
          this.note.textContent = 'Im Warenkorb. ';
          const a = document.createElement('a');
          a.href = '/cart';
          a.textContent = 'Zum Warenkorb';
          this.note.appendChild(a);
        }
      } catch (err) {
        console.error('[noms+ Bundle]', err);
        if (label) label.textContent = before;
        this.btn.disabled = false;
        if (this.note) {
          this.note.dataset.sticky = '1';
          this.note.textContent = 'Das hat leider nicht geklappt. Bitte lade die Seite neu.';
        }
      }
    }
  }

  if (!customElements.get('nplus-bundle')) {
    customElements.define('nplus-bundle', NplusBundle);
  }
})();
